export const FRENCH = 'FR';
export const EUROPE = 'EU';
export const OUTSIDE_EUROPE = 'outsideEU';
export const HIGH_RISK_COUNTRY = 'riskCountry';
